export default __webpack_public_path__ + "static/media/basketball.36d30be2.jpg";